import { Directive, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appBusinessId]',
  standalone: true
})
export class BusinessIdDirective {

  @Input() minLength?: number;
  @Input() maxLength?: number;

  constructor(private control: NgControl) { }

  @HostListener('input', ['$event'])
  onInput(event: InputEvent) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    // Clean invalid characters (allow alphanumeric and hyphen '-')
    value = value.replace(/[^a-zA-Z0-9-]/g, '');

    // Enforce max length (trim extra)
    if (this.maxLength !== undefined && value.length > this.maxLength) {
      value = value.substring(0, this.maxLength);
    }

    // Valid full pattern: 4 letters + hyphen + digits
    const fullPattern = /^[a-zA-Z]{4}-[0-9]+$/;

    // Allow partial input as long as it's on the path to becoming valid
    const partialPattern = /^[a-zA-Z]{0,4}-?[0-9]*$/;

    if (value === '' || fullPattern.test(value) || partialPattern.test(value)) {
      // Optionally enforce min length (when full pattern is typed)
      if (this.minLength !== undefined && value.length < this.minLength && fullPattern.test(value)) {
        // keep the value, but you may want to show a message elsewhere
      }
      this.control.control?.setValue(value);
    } else {
      // Remove last invalid character
      value = value.slice(0, -1);
      this.control.control?.setValue(value);
    }
  }
}
